import React, { useEffect } from 'react'
import StaffWrapper from '../StaffWrapper'
import StaffNavItem from './StaffNavItem'
import { InfoOutlined, NotificationsNoneOutlined, ReportProblemOutlined, RequestQuoteOutlined, SummarizeOutlined } from '@mui/icons-material'
//import { LocalShippingOutlined ReceiptLongOutlined } from '@mui/icons-material'
import { useTranslation } from 'react-i18next'
import ComplaintNavItem from '../../Client/NavItems/ComplaintNavItem'
import { connect, useDispatch } from 'react-redux'
import { fetchUnreadComplaintsCount } from '../../../actions/complaint/complaintList'
import { Collapse } from '@mui/material'
import { SessionState } from '../../../reducers/auth/session'
import { GeneralDescState } from '../../../reducers/generalDescList'
import { AppState } from '../../../reducers'
import { fetchGeneralDesc } from '../../../actions/generalDesc'

interface StateProps {
  session?: SessionState
  generalDescList?: GeneralDescState
}

// Props que vienen del padre
interface OwnProps {
  open?: boolean
  // otras props que uses desde NavMenu
}

// Combinación para el componente
type Props = StateProps & OwnProps;

const StaffNavItems: React.FC<Props> = ({ session, generalDescList, ...props }) => {
  const { t } = useTranslation("menu")
  const dispatch = useDispatch()
  const [openDownload, setOpenDownload] = React.useState(false);
  const [generalDescListState, setGeneralDescListState] = React.useState<any>(undefined);

  useEffect(() => {
    dispatch(fetchGeneralDesc('', (response) => {
      setGeneralDescListState(response)
    }))

    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [])

  const isLogistic = generalDescListState?.generalDesc?.some(gd => gd.id === session?.categoryId && gd.code === 'log');
  const isAccounts = generalDescListState?.generalDesc?.some(gd => gd.id === session?.categoryId && gd.code === 'cc');

  const handleDownloadClick = () => {
    setOpenDownload(!openDownload);
  };


  const getComplaintCount = () => {
    dispatch(fetchUnreadComplaintsCount())
  }

  useEffect(() => {
    getComplaintCount()
    // eslint-disable-next-line react-hooks/exhaustive-deps    
  }, [])


  return <StaffWrapper>
    {(isLogistic || isAccounts) &&
      <StaffNavItem
        uri='clients'
        title={t('clients')}
        icon='people'
        {...props}
      />}

    {/*<StaffNavItem
      uri='accounts'
      title={t('account')}
      icon='attach_money'
      {...props}
    />

    <StaffNavItem
      uri='orders'
      title={t('orders')}
      icon={<LocalShippingOutlined />}
      {...props}
/>*/}

    <ComplaintNavItem
      base='staff'
      uri='complaints'
      title={t('complaintsList')}
      icon={<ReportProblemOutlined />}
      {...props}
    />

    {(isAccounts) && (
      <StaffNavItem
        uri='downloads'
        title={t('downloadReport')}
        nested
        icon={<InfoOutlined />}
        onClick={handleDownloadClick}
        openItem={openDownload}
        {...props}
      />)}

    {(isAccounts) && (
      <Collapse in={openDownload} timeout="auto" style={{
        marginTop: openDownload ? props.open ? "-16px" : "-6px" : "0px",
        marginBottom: openDownload ? props.open ? "-16px" : "-6px" : "-16px"
      }}>
        <StaffNavItem
          uri='dlPriceList'
          title={t('priceList')}
          icon={<RequestQuoteOutlined />}
          subItem
          {...props}
        />
        <StaffNavItem
          uri='currentAccountSummary'
          title={t('currentAccountSummary')}
          icon={<SummarizeOutlined />}
          subItem
          {...props}
        />
      </Collapse>
    )}

    <StaffNavItem
      uri='notifications'
      title={t('notifications')}
      icon={<NotificationsNoneOutlined />}
      {...props}
    />

    {/*<StaffNavItem
      uri='payments'
      title={t('paymentsList')}
      icon={<ReceiptLongOutlined />}
      {...props}
/>*/}
  </StaffWrapper>
}

const mapStateToProps = (state: AppState): StateProps => ({
  session: state.session,
  generalDescList: state.generalDescList
})

// Ahora TypeScript sabe que open es prop propia (OwnProps)
export default connect<StateProps, {}, OwnProps, AppState>(mapStateToProps)(StaffNavItems);